import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLandmark, 
  faHistory, 
  faTools, 
  faBuilding,
  faSearchPlus,
  faHandshake
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const DenkmalschutzPage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faLandmark} />
            </div>
            <h1>Denkmalschutz</h1>
            <p>
              Fachgerechte Planung für denkmalgeschützte Gebäude und historische Bausubstanz
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="service-section">
            <h2 className="service-section-title">Elektroplanung im Denkmalschutz</h2>
            <p>
              Das Ingenieurbüro Neubaur verfügt über umfangreiche Erfahrung in der Elektroplanung für denkmalgeschützte 
              Gebäude und historische Bausubstanz. Wir verbinden moderne Technik mit historischer Architektur und 
              berücksichtigen dabei die besonderen Anforderungen des Denkmalschutzes.
            </p>
            <p>
              Unsere Planungen zeichnen sich durch besondere Sensibilität für die historische Bausubstanz aus. 
              Wir entwickeln individuelle Lösungen, die den Charakter des Gebäudes bewahren und gleichzeitig 
              moderne Nutzungsanforderungen erfüllen.
            </p>
          </section>

          {/* Features Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Leistungen im Bereich Denkmalschutz</h2>
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faSearchPlus} />
                </div>
                <h3 className="service-feature-title">Bestandsaufnahme</h3>
                <p className="service-feature-text">
                  Sorgfältige Erfassung und Dokumentation der bestehenden elektrotechnischen Anlagen und baulichen Gegebenheiten.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faHistory} />
                </div>
                <h3 className="service-feature-title">Historische Recherche</h3>
                <p className="service-feature-text">
                  Recherche zu historischen Elektroinstallationen und -komponenten für eine stilgerechte Planung.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faTools} />
                </div>
                <h3 className="service-feature-title">Behutsame Sanierung</h3>
                <p className="service-feature-text">
                  Planung von Elektroinstallationen mit minimalem Eingriff in die historische Bausubstanz.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faBuilding} />
                </div>
                <h3 className="service-feature-title">Stilgerechte Lösungen</h3>
                <p className="service-feature-text">
                  Entwicklung von Lösungen, die sich harmonisch in das historische Erscheinungsbild einfügen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faHandshake} />
                </div>
                <h3 className="service-feature-title">Behördenkommunikation</h3>
                <p className="service-feature-text">
                  Abstimmung mit Denkmalschutzbehörden und Unterstützung bei Genehmigungsverfahren.
                </p>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unser Ansatz im Denkmalschutz</h2>
            <div className="service-process">
              <div className="process-step">
                <div className="process-number">1</div>
                <div className="process-content">
                  <h3 className="process-title">Sorgfältige Bestandsaufnahme</h3>
                  <p className="process-text">
                    Wir erfassen den Bestand detailliert und dokumentieren alle relevanten Aspekte des Gebäudes.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">2</div>
                <div className="process-content">
                  <h3 className="process-title">Analyse der Anforderungen</h3>
                  <p className="process-text">
                    Wir analysieren die Nutzungsanforderungen und denkmalschutzrechtlichen Vorgaben.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">3</div>
                <div className="process-content">
                  <h3 className="process-title">Entwicklung von Lösungsansätzen</h3>
                  <p className="process-text">
                    Wir entwickeln verschiedene Lösungsansätze unter Berücksichtigung des Denkmalschutzes.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">4</div>
                <div className="process-content">
                  <h3 className="process-title">Abstimmung mit Behörden</h3>
                  <p className="process-text">
                    Wir stimmen die Planungen mit den zuständigen Denkmalschutzbehörden ab.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">5</div>
                <div className="process-content">
                  <h3 className="process-title">Detailplanung</h3>
                  <p className="process-text">
                    Wir erstellen detaillierte Planungen unter besonderer Berücksichtigung der historischen Bausubstanz.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">6</div>
                <div className="process-content">
                  <h3 className="process-title">Baubegleitung</h3>
                  <p className="process-text">
                    Während der Bauphase überwachen wir die fachgerechte und denkmalgerechte Ausführung.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-cta">
            <h2 className="service-cta-title">Erfahrung im Denkmalschutz für Ihr Projekt</h2>
            <p className="service-cta-text">
              Nutzen Sie unsere langjährige Erfahrung im Bereich Denkmalschutz für Ihr Sanierungsprojekt. 
              Wir beraten Sie gerne zu den Möglichkeiten und entwickeln gemeinsam mit Ihnen die optimale Lösung.
            </p>
            <Link to="/kontakt" className="btn btn-primary">
              Kontakt aufnehmen
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DenkmalschutzPage;
